import type { OptionTypeBase } from 'react-select';

import { type SelectType } from './SelectType';
import { SelectWrapper } from './SelectWrapper';
import { useSelectInternals } from './hooks';
import type { BaseSelectProps } from './types';
import { getRenderSelectFunction } from './utils';

export const BaseSelect = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
  T extends SelectType,
>(
  props: BaseSelectProps<OptionType, IsMulti, T>,
) => {
  const { selectWrapperProps, renderSelectProps } = useSelectInternals<
    OptionType,
    IsMulti,
    T
  >(props);

  const { selectType } = props;

  const renderSelect = getRenderSelectFunction<OptionType, IsMulti, T>(
    selectType,
  );

  const select = renderSelect(renderSelectProps);

  return <SelectWrapper {...selectWrapperProps}>{select}</SelectWrapper>;
};
